import * as React from "react";
import AddressForm from "./AddressForm";
import styles from "./styles.module.css";
import PostcodeForm from "./PostcodeForm";
import { LeadContext } from "@/context/lead";
import { Address, Error } from "@/types/index";
import { FormError } from "@/components/Shared";
import { getAddresses } from "@/utils/formatApiError";

const Address: React.FC<{
	setAddress: React.Dispatch<React.SetStateAction<Address[]>>;
}> = ({ setAddress }) => {
	const { postcode } = React.useContext(LeadContext);
	const [error, setError] = React.useState<Error | null>(null);
	const [isLoading, setLoading] = React.useState<Boolean>(false);
	const [addresses, setAddresses] = React.useState<Address[]>([]);

	React.useEffect(() => {
		if (postcode === "") {
			return;
		}

		const fetchAddresses = async () => {
			setLoading(true);

			const { data, error } = await getAddresses(postcode);

			setError(error);
			setAddresses(data);
			setLoading(false);
		};

		fetchAddresses();
	}, [postcode]);

	return (
		<section className="container-sm-fixed text-center pt-5 pb-5 mx-auto ">
			<div>
				<div className={styles.title}>What is your postcode?</div>
				<p className="mt-4">
					Enter your postcode below and click ‘Find Address’. Then choose your
					address from the selection that appears.
				</p>
			</div>
			{addresses.length > 0 ? (
				<AddressForm addresses={addresses} setAddress={setAddress} />
			) : (
				<>
					{error && <FormError message={error.message} theme="dark" />}
					<PostcodeForm isLoading={isLoading} />
				</>
			)}
		</section>
	);
};

export default Address;
